<script>

    import { onMount } from 'svelte';

    import Keypad from "./keypad.svelte";


    export let currentQuestion;

    export let ansChanged;

    export let thisQUserResponses;

    export let questionVisited;

    export let language;

    export let mode = "";

    questionVisited({
        qId: currentQuestion._id,
        q_id: currentQuestion.qId
    })

    if (mode == "reattempt") {
        thisQUserResponses.answer = "";
    }

    if(thisQUserResponses.answer == null || thisQUserResponses.answer == 'null' ){
        thisQUserResponses.answer = ""
    }

    onMount(async () => {
        console.log("thisQUserResponses.answer", thisQUserResponses.answer)
        if(!thisQUserResponses.answer || thisQUserResponses.answer=="undefined" || thisQUserResponses.answer=="null"){
            thisQUserResponses.answer="";
        }
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    })

    let valueUpdated = function(value){
    
    }

    let onchange = function(){
        console.log("Value updated ", thisQUserResponses.answer);
        ansChanged({
            qId: currentQuestion._id,
            ans: thisQUserResponses.answer
        });
    }


</script>

<div class="q-option">
    <div class="q-label">
        Answer :
    </div>
    <ul>

       

        <li class="correct option-li">

            <div class="op-label" style="position: relative;" 
                class:correctly-answered={ 
                        mode=="review" && thisQUserResponses.answer == currentQuestion.data.answer
                    }
                class:correct-answer={
                        mode=="review" && !thisQUserResponses.answer
                    } 
                class:wrongly-answered={
                        mode=="review" && thisQUserResponses.answer != currentQuestion.data.answer
                    }>
                <div class="op-data-div">
                    <div class="op-action">
                        {#if mode=="review"}

                            {#if (thisQUserResponses.answer == currentQuestion.data.answer)}
                            <!-- this is correctly answered -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="feather feather-check">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            {:else if (!thisQUserResponses.answer)}
                            <!-- this is not answered but correct -->
                            <svg xmlns="http://www.w3.org/2000/svg" style="opacity: 0;" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="feather feather-check">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            {:else if (thisQUserResponses.answer != currentQuestion.data.answer)}
                            <!-- this is answered but wrong -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="feather feather-x">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                            {:else}
                            <div class="blank-option">

                            </div>
                            {/if}

                        {:else}
                        <div class="option-action i-input">
                            <label></label>
                        </div>
                        {/if}
                    </div>
                    <div class="op-data" style="display: flex;    flex-direction: column;">
                        <div class="option-content" style="    height: 40px;
    padding: 0 10px;
    border: 1px solid rgb(221, 221, 221);
    width: -webkit-fill-available;
    margin-bottom: 10px;
    display: flex;
    align-items: center;"> 
                            <span>{(!thisQUserResponses.answer || thisQUserResponses.answer==null || thisQUserResponses.answer =="null")?"":thisQUserResponses.answer}</span> </div>

                            {#if mode!="review"}
                                <Keypad bind:value={thisQUserResponses.answer} onchange={onchange} />
                            {/if}
                        
                    </div>
                </div>
                {#if mode=="review"}
                    {#if thisQUserResponses.answer == currentQuestion.data.answer}
                    <div class="op-res-div">
                        Your answer is correct
                    </div>
                    {:else if !thisQUserResponses.answer}
                    <div class="op-res-div wrong">
                        Not Attempted
                    </div>

                    {:else if thisQUserResponses.answer != currentQuestion.data.answer}
                    <div class="op-res-div wrong">
                        Your answer is wrong
                    </div>

                    {/if}
                {/if}
            </div>
        </li>




        {#if mode=="review" && (thisQUserResponses.answer != currentQuestion.data.answer || !thisQUserResponses.answer)}
            <li class="correct option-li">
                <div class="op-label correct-answer" style="position: relative;" >
                    <div class="op-data-div">
                        <div class="op-action">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="feather feather-check">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                        <div class="op-data" style="display: flex;    flex-direction: column;">
                            <div class="option-content" style="    height: 40px;
                                padding: 0 10px;
                                border: 1px solid rgb(221, 221, 221);
                                width: -webkit-fill-available;
                                margin-bottom: 10px;
                                display: flex;
                                align-items: center;">
                                <span>{currentQuestion.data.answer}</span>
                            </div>
                        </div>
                    </div>
                    <div class="op-res-div">
                        This is correct answer
                    </div>
                
                </div>
            </li>
        {/if}
        

    </ul>
</div>

<style>
    /* This dummy style forces Rollup to generate bundle.css */
    .dummy-class-to-force-css-build {
        display: block;
    }
</style>